import { PwaUpdateContext } from './context';
import { PwaUpdateProviderProps } from './types';
import { usePwaUpdate } from './usePwaUpdate';

const PwaUpdateProvider = ({ children, isReloadDeferred }: PwaUpdateProviderProps) => {
  const value = usePwaUpdate(isReloadDeferred);

  return (
    <PwaUpdateContext.Provider value={value}>
      {children}
    </PwaUpdateContext.Provider>
  );
};

export default PwaUpdateProvider;